export const convertDate = (date: string | null) => {

    if (!date) {
        return "N/A"
    }

    let convertedDate: string = date.split('T')[0];

    convertedDate = convertedDate.split("-").reverse().join(".");

    return convertedDate;
};